"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOssSignatureApi = getOssSignatureApi;
var _request = _interopRequireDefault(require("@/utils/request"));
// oss签名

function getOssSignatureApi(params) {
  return (0, _request.default)({
    url: "/portal/system/file/getOssSignature",
    method: "get",
    params: params
  });
}